'use strict'

var regex = /^[A-F0-9]{8}(?:-?[A-F0-9]{4}){3}-?[A-F0-9]{12}$/i
var regex2 = /^\{[A-F0-9]{8}(?:-?[A-F0-9]{4}){3}-?[A-F0-9]{12}\}$/i

module.exports = function(value){
    return regex.test(value) || regex2.test(value)
}




/*****************
 ** WEBPACK FOOTER
 ** ./~/ustring/src/is/guid.js
 ** module id = 848
 ** module chunks = 0
 **/